module.exports = __webpack_public_path__ + "images/close.94a0c7c34036663fbd2cb7ae02bd3757.png";